import type { ProjectGraphNode } from '@avisoma/shared';

/** A short human label for a node. Kinds added after this release show their id. */
export function nodeLabel(node: ProjectGraphNode): string {
  switch (node.kind) {
    case 'engine':
      return `ESN ${node.esn}`;
    case 'aircraft':
      return node.registration;
    case 'part':
      return `P/N ${node.partNumber} · S/N ${node.serialNumber}`;
    case 'reference': {
      const label = `${node.refKind.toUpperCase()} ${node.number}`;
      // Sibling tasks under one reference differ only by their description (DR-4982), so a task label names it
      // whole: siblings can differ late, and every list cuts a label to its width and shows it whole on hover.
      const title = node.refKind === 'task' && node.title ? node.title.replace(/\s+/g, ' ').trim() : '';
      return title ? `${label} · ${title}` : label;
    }
    case 'document':
    case 'event':
      return node.title;
    case 'ipc':
      return `${node.subject} fig ${node.figure} item ${node.item}`;
    default:
      return (node as { id: string }).id;
  }
}
